// extracted by mini-css-extract-plugin
export default {"logo_container":"LogoMobileVersion_logo_container__MupWD","logo":"LogoMobileVersion_logo__HHI-U"};